module.exports = __webpack_public_path__ + "img/1447768456.e9fcf8ec.jpg";